function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 40
// module chunks = 0